import React from 'react';

const Loader = () => {
  return (
    <div role="loader" className="flex gap-1.5 items-center">
      <div className="mr-2 h-7 w-7 animate-spin fill-primary border-[3px] rounded-[50%] border-t-primary-main border-b-primary-main border-l-white border-r-white"></div>
    </div>
  );
};

export default Loader;
